import Auth from "@aws-amplify/auth";

async function generateToken() {
  const user = await Auth.currentAuthenticatedUser();
  const jwt = user
    .getSignInUserSession()
    .getAccessToken()
    .getJwtToken();
  return jwt;
}
export default generateToken;
